// Organization settings strings — EN + TR.
//
// Wave-2 Day 1. Business details + contact + address + defaults cards.
// Edit affordance + mock-only toasts. Volkan direction 2026-05-23
// (Settings 10-section expansion item #1).
//
// Source: features/settings/Organization.tsx.

import type { LocalizedDict } from '../index'

type OrganizationStrings = {
  pageTitle: string
  pageDescriptionLead: string
  pageDescriptionTail: string
  footerNote: string
  toastTail: string
  business: {
    title: string
    description: string
    legalName: string
    displayName: string
    entityType: string
    registrationNumber: string
    taxId: string
  }
  contact: {
    title: string
    description: string
    primaryEmail: string
    supportEmail: string
    phone: string
  }
  address: {
    title: string
    description: string
    street: string
    unit: string
    city: string
    region: string
    postalCode: string
    country: string
  }
  defaults: {
    title: string
    description: string
    currency: string
    region: string
    unitSystem: string
    weightUnit: string
    timezone: string
    language: string
  }
}

export const organizationI18n: LocalizedDict<OrganizationStrings> = {
  en: {
    pageTitle: 'Organization',
    pageDescriptionLead:
      'Business identity, contact details, address, and operational defaults for ',
    pageDescriptionTail: '.',
    footerNote:
      'Mock data · backend persistence M3 Stage 4 SPEC.md Faz 1 (memberships + scope_family foundational tables).',
    toastTail:
      'Persistence wires to M3 Stage 4 SPEC.md Faz 1 ratification.',
    business: {
      title: 'Business details',
      description:
        'Legal entity used on invoices and official correspondence.',
      legalName: 'Legal name',
      displayName: 'Display name',
      entityType: 'Entity type',
      registrationNumber: 'Registration #',
      taxId: 'Tax ID',
    },
    contact: {
      title: 'Contact details',
      description: 'Primary contact channels routed to operational owners.',
      primaryEmail: 'Primary email',
      supportEmail: 'Support email',
      phone: 'Phone',
    },
    address: {
      title: 'Address',
      description:
        'Operational address — appears on labels, packing slips, and invoices.',
      street: 'Street',
      unit: 'Unit / building',
      city: 'City',
      region: 'Region',
      postalCode: 'Postal code',
      country: 'Country',
    },
    defaults: {
      title: 'Defaults',
      description:
        'Currency, region, unit system, and timezone applied across the org.',
      currency: 'Currency',
      region: 'Region',
      unitSystem: 'Unit system',
      weightUnit: 'Weight unit',
      timezone: 'Timezone',
      language: 'Language',
    },
  },
  tr: {
    pageTitle: 'Organizasyon',
    pageDescriptionLead:
      'İş kimliği, iletişim bilgileri, adres ve operasyonel varsayılanlar: ',
    pageDescriptionTail: '.',
    footerNote:
      'Mock veri · backend kalıcılığı M3 Stage 4 SPEC.md Faz 1 (memberships + scope_family temel tablolar).',
    toastTail:
      'Kalıcı kayıt M3 Stage 4 SPEC.md Faz 1 ratify ile bağlanır.',
    business: {
      title: 'İş bilgileri',
      description: 'Fatura ve resmi yazışmalarda kullanılan tüzel kişilik.',
      legalName: 'Yasal ad',
      displayName: 'Gösterilen ad',
      entityType: 'Tüzel kişilik türü',
      registrationNumber: 'Sicil no',
      taxId: 'Vergi no',
    },
    contact: {
      title: 'İletişim bilgileri',
      description:
        'Operasyonel sorumlulara yönlendirilen birincil iletişim kanalları.',
      primaryEmail: 'Birincil e-posta',
      supportEmail: 'Destek e-postası',
      phone: 'Telefon',
    },
    address: {
      title: 'Adres',
      description:
        'Operasyonel adres — etiketler, paket fişleri ve faturalarda görünür.',
      street: 'Sokak / cadde',
      unit: 'Daire / bina',
      city: 'Şehir',
      region: 'Bölge',
      postalCode: 'Posta kodu',
      country: 'Ülke',
    },
    defaults: {
      title: 'Varsayılanlar',
      description:
        'Organizasyon genelinde uygulanan para birimi, bölge, birim sistemi ve saat dilimi.',
      currency: 'Para birimi',
      region: 'Bölge',
      unitSystem: 'Birim sistemi',
      weightUnit: 'Ağırlık birimi',
      timezone: 'Saat dilimi',
      language: 'Dil',
    },
  },
}
